import { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import './bnrFonts.css';
import { useOutletContext } from 'react-router-dom';
import { useRegionContext } from '../context/RegionContext';
import { BASE_URI, MIN_STATEMENT_LENGTH } from '../globals';
import WidgetPartyButtons from '../components/WidgetPartyButtons';
import { useSearchParamsState, useFetchGetRef } from '../hooks';

export default function EmbeddedView() {
    const { region } = useRegionContext();
    const { election } = useOutletContext();
    const [statement, setStatement] = useSearchParamsState('query', '');
    const firstRender = useRef(true);
    const [customize, setCustomize] = useState(false);
    const { refData: parties, setRefUrl: setPartiesUrl } = useFetchGetRef(null, []);
    const [showHelper, setShowHelper] = useState(false);

    useEffect(() => {
        if (election) {
            setPartiesUrl(`${BASE_URI}/election/${election.uuid}/party/`);
        }
    }, [election]);

    useEffect(() => {
        if (firstRender.current && !statement) {
            setCustomize(true);
        }

        if (firstRender.current) {
            firstRender.current = false;
        }
    }, [statement]);

    const computeLink = party =>
        `https://${region}.openverkiezingen.nl` +
        `?parties=${party.slug}&query=${statement}&bnr=true`;

    const onPartyClick = party => {
        if (statement.length >= MIN_STATEMENT_LENGTH) {
            const link = computeLink(party);
            window.open(link, '_blank');
        } else {
            setShowHelper(true);
        }
    };

    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                p: '10px',
                pb: '35px',
                display: 'flex',
                alignItems: 'start',
                justifyContent: 'start',
                flexDirection: 'column'
            }}>
            <Box
                sx={{
                    width: '100%'
                }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'start'
                    }}>
                    <img
                        src="/bnrElements/bnrArrow.svg"
                        style={{ marginTop: '5px', marginRight: '15px' }}
                        alt="arrow"
                    />
                    <Typography
                        sx={{
                            fontSize: '0.875rem',
                            fontFamily: 'Plus Jakarta Sans, Helvetica',
                            fontWeight: 'bold',
                            mt: '15px',
                            color: '#000000'
                        }}>
                        Wat vinden de partijen van...
                    </Typography>
                </Box>

                {statement && !customize && (
                    <Typography
                        sx={{
                            fontSize: '1.125rem',
                            color: '#000000',
                            fontFamily: 'Plus Jakarta Sans, Helvetica',
                            fontWeight: '700'
                        }}>
                        {statement}
                    </Typography>
                )}

                {(customize || !statement) && (
                    <TextField
                        fullWidth
                        onChange={e => {
                            setShowHelper(false);
                            setStatement(e.target.value);
                        }}
                        id="standard-basic"
                        sx={{
                            mb: 2,
                            mt: '-5px'
                        }}
                        label="Typ hier jouw stelling..."
                        value={statement}
                        error={!!showHelper}
                        helperText={!!showHelper && `Typ een stelling en klik op een partij`}
                        multiline
                        maxRows={2}
                        variant="standard"
                    />
                )}
            </Box>

            <Box sx={{ flexGrow: 1, width: '100%', position: 'relative' }}>
                <WidgetPartyButtons
                    parties={parties}
                    onClick={onPartyClick}
                    computeLink={computeLink}
                    linkProps={{ target: '_blank' }}
                    defaultElection={election}
                />
            </Box>
        </Box>
    );
}
